import { createPersistedState } from "@edreamsodigeo/frontend-core";

import usePersistedFlightSelectionData from "~/clientState/sessionStorage/persistedFlightSelectionData";

const useHasFlightDiscountSelectedBySessionStorage = ():
  | boolean
  | undefined => {
  const [flightSelectionData] = usePersistedFlightSelectionData();
  const subscriptionSelectedOnContinueData = createPersistedState<string>({
    type: "sessionStorage",
    key: "subscriptionSelectedOnContinue",
    isGlobal: true,
  });
  const [subscriptionSelectedOnContinue] = subscriptionSelectedOnContinueData();

  return (
    !flightSelectionData?.data?.priceWithoutDiscountSelected ||
    subscriptionSelectedOnContinue === "prime"
  );
};

export default useHasFlightDiscountSelectedBySessionStorage;
